export default {
  paged: {
    select: 'id,email,isSuccessfulOperation,accessType,operationType,created,city,state,ip',
    searchSelect: ['user', 'observations'],
    notSelectSearch: 'appClient',
    expand: {
      appClient: {
        select: 'applicationName',
      },
      country: {
        select: 'name',
      },
    },
    orderBy: 'created desc',
  },
  itemDetail: {
    select:
      'id,email,isSuccessfulOperation,internalUserId,userId,ip,accessType,operationType,created,observations,city,state,userAgent',
    expand: {
      appClient: {
        select: 'applicationName',
      },
      country: {
        select: 'name',
      },
    },
  },
};
